import {type IInvoiceFile, type InvoiceDocument, InvoiceDocumentSchema} from "@mytour/shared";
import axios from "axios";

export const invoiceDocumentApiService = {
  async listCustomerDocuments(customerId: string): Promise<InvoiceDocument[]> {
    const {data} = await axios.get(`/api/invoice-files/customer/${customerId}`);
    return InvoiceDocumentSchema.array().parse(data);
  },
  async downloadFile(invoiceId: string): Promise<Blob> {
    const {data} = await axios.get<IInvoiceFile>(`/api/invoice-files/${invoiceId}`);
    const blob = data.blob as unknown as {data?: number[]};
    if (!Array.isArray(blob?.data)) {
      throw new Error("Invoice file is unavailable");
    }
    return new Blob([new Uint8Array(blob.data)], {type: "application/pdf"});
  },
};
